var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseTileMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 330 330",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5197"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5169"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5131"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4918"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4917"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4916"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4915"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4914",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4913"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.767 246.484a40.284 40.284 0 11-40.284-40.284 40.284 40.284 0 0140.284 40.284",
    fill: "#fff",
    "data-name": "Path 10929"
  })))))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.495 253.391l6.955-4.786a83.212 83.212 0 0010.751.042c1.572-.164 4.323-.671 7.06-1.221l3.913 2.771 10.732.645 5.614 2.053 7.922 4.993 7.864 2.827 3.441 7.486 25.92-4.078 8.651-3.669 5.768 1.311 9.7-2.1 5.768 3.408 9.437 2.1 11.489 10.3 8.682 3.1 4.574-1.192 6.773-2.321 4.966-2.738 8.252-1.143 4.417-2.839c3.662-.581 7.87-1.671 8.766-2.3a7.285 7.285 0 013.428-.69s8.975-2.102 13.237-4.345 4.762-1.439 7.142-2.159 4.1-5.915 4.648-6.687 7.988-4.233 9.836-4.7 5.338-3.258 7.464-4.246 8.116.492 8.116.492 8.116.491 10.481.3 6.342-1.656 8.453-2.121a17.691 17.691 0 014.477-.661c1.31.037 5.757.426 5.757.426s3.842 3.255 6.477 2.806 10.9 3.981 15.828 5.956 8.116.491 8.116.491 4.484-.922 5.787-.622 7.5 3.622 8.806 3.92 7.022 2.035 8.587 2.342 7.33.469 9.427.529 3.218-2.532 5.061-2.742 3.616 1.938 5.451 1.99a31.955 31.955 0 015.495.417c.779.285 8.994 6.549 8.994 6.549v93.118H-25.286l13.471-98.675z",
    fill: "#fff",
    "data-name": "Path 11581"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseTileMountains);
export default __webpack_public_path__ + "static/media/purchaseTileMountains.53feb623710183a76c9a7d6f4a5546b5.svg";
export { ForwardRef as ReactComponent };